import { GET_ACTIVE_LOCATION_OPTIONS_PENDING, GET_ACTIVE_LOCATION_OPTIONS_SUCCESS, GET_ACTIVE_LOCATION_OPTIONS_FAILURE } from './types';
import baseUrl from '../../url';

const fetchLocationRequest = () => {
    return {
        type: GET_ACTIVE_LOCATION_OPTIONS_PENDING
    }
}

const fetchLocationSuccess = location => {
    return {
        type: GET_ACTIVE_LOCATION_OPTIONS_SUCCESS,
        payload: location,
    }
}

const fetchLocationFailure = error => {
    return {
        type: GET_ACTIVE_LOCATION_OPTIONS_FAILURE,
        payload: error,
    }
}

export const getActiveLocationOptions = (slug, cityId) => {
    return (dispatch) => {
        dispatch(fetchLocationRequest());
        const token = localStorage.getItem('token');
        fetch(`${baseUrl}/projects/${slug}/location_options?city_id=${cityId}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchLocationSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchLocationFailure(error.message));
            })
    }
}